import {ReservationTicketComponent} from './pages/reservation-ticket/reservation-ticket.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { LoginComponent } from './login/login.component';
import { ModernModeGuard } from './login/auth/modern-mode.guard';
import { RegisterComponent } from './views/pages/register/register.component';
import { ManuelReservationComponent } from './pages/manuel-reservation/manuel-reservation.component';
import { CancelReservationComponent } from './pages/cancel-reservation/cancel-reservation.component';
import { EditReservationComponent } from './pages/edit-reservation/edit-reservation.component';
import { EditAppointmentComponent } from './pages/edit-appointment/edit-appointment.component';
import { ManualAppointmentComponent } from './pages/manual-appointment/manual-appointment.component';
import { ConfirmReservationComponent } from './pages/confirm-reservation/confirm-reservation.component';
import { OnboardingFinalizeComponent } from './onboarding/onboarding-finalize/onboarding-finalize.component';
import { BookAppointmentComponent } from './pages/book-appointment/book-appointment.component';
import { RescheduleAppointmentComponent } from './pages/reschedule-appointment/reschedule-appointment.component';

import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { DevModeGuard } from './login/auth/dev-mode.guard';
import { PickerSessionGuard } from './login/auth/picker-session.guard';
import { PageAccessGuard } from './login/auth/page-access.guard';
import { DASHBOARD_LAYOUT_GUARDS, LANDING_ROUTE, MARS_ROUTES } from './mars/mars.routes';
const routes: Routes = [
  {path:'r/:token',component:ReservationTicketComponent,data:{title:'Reservation ticket'}},
  {
    path: 'consent',
    loadComponent: () => import('./pages/customer-consent/customer-consent.component').then(m => m.CustomerConsentComponent),
    data: { title: 'İletişim tercihleri' }
  },
  {
    // DEV-ONLY public API chat tester. DevModeGuard blocks it in production builds.
    path: 'api-chat-test',
    loadComponent: () =>
      import('./pages/api-chat-test/api-chat-test.component').then(
        (m) => m.ApiChatTestComponent
      ),
    canActivate: [DevModeGuard],
    data: {
      title: 'API Chat Tester'
    }
  },
  {
    path: 'confirm/:companyName/:reservationId',
    component: ConfirmReservationComponent,
    data: {
      title: 'Confirm Reservation'
    }
  },
  {
    path: 'cancel/:companyName/:reservationId',
    component: CancelReservationComponent,
    data: {
      title: 'Cancel Reservation'
    }
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'manual-reservation/:companyName',
    component: ManuelReservationComponent,
    data: {
      title: 'Manuel Reservations'
    }
  },
  {
    path: 'edit/:companyName/:reservationId',
    component: EditReservationComponent,
    data: {
      title: 'Edit Reservation'
    }
  },
  {
    path: 'edit-appointment/:companyName/:reservationId',
    component: EditAppointmentComponent,
    data: {
      title: 'Edit Appointment'
    }
  },
  {
    path: 'manual-appointment/:companyName',
    component: ManualAppointmentComponent,
    data: {
      title: 'New Appointment'
    }
  },
  {
    path: 'book/:companyName',
    component: BookAppointmentComponent,
    data: {
      title: 'Book Appointment'
    }
  },
  {
    path: 'reschedule-general/:companyName/:reservationId',
    component: RescheduleAppointmentComponent,
    data: {
      title: 'Reschedule Appointment'
    }
  },
  {
    // C29: superuser picker — outside DefaultLayout, like /login.
    path: 'profiles',
    loadComponent: () =>
      import('./login/profile-picker/profile-picker.component').then(
        (m) => m.ProfilePickerComponent
      ),
    canActivate: [PickerSessionGuard],
    data: {
      title: 'Profiles'
    }
  },
  ...MARS_ROUTES,
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    // Waiter and kitchen sessions never enter the dashboard layout.
    canActivate: DASHBOARD_LAYOUT_GUARDS,
    children: [
      {
        path: 'onboarding/finalize',
        component: OnboardingFinalizeComponent,
        canActivate: [ModernModeGuard],
        data: {
          title: 'Finalize Onboarding'
        }
      },
      {
        path: 'dashboard',
        canActivate: [PageAccessGuard],
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule)
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule)
      },
      {
        path: 'theme',
        loadChildren: () =>
          import('./views/theme/theme.module').then((m) => m.ThemeModule)
      },
      {
        path: 'base',
        loadChildren: () =>
          import('./views/base/base.module').then((m) => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () =>
          import('./views/buttons/buttons.module').then((m) => m.ButtonsModule)
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./views/forms/forms.module').then((m) => m.CoreUIFormsModule)
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./views/charts/charts.module').then((m) => m.ChartsModule)
      },
      {
        path: 'icons',
        loadChildren: () =>
          import('./views/icons/icons.module').then((m) => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./views/notifications/notifications.module').then((m) => m.NotificationsModule)
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./views/widgets/widgets.module').then((m) => m.WidgetsModule)
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule)
      },
    ]
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: { title: 'Forgot Password' }
  },
  LANDING_ROUTE,
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
